var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Body1, Body2, Selected } from "../Text";
import { Div } from "../utils";
import { CheckboxInput } from "./CheckboxInput";
import { RadioInput } from "./RadioInput";
const variants = ["radio", "checkbox"];
const HoverIndicator = styled(Div) `
  background: ${(p) => p.theme.colors.gray2};
  height: 30px;
  width: 30px;
  border-radius: 100%;
  display: none;
`;
const SelectableContainer = styled(Div) `
  border-radius: 100%;
  ${(p) => p.theme.css.centered};
  :hover {
    cursor: pointer;
    ${HoverIndicator} {
      display: block;
    }
  }
`;
export const Selectable = (_a) => {
    var { label, value, onChange, variant = "radio", description } = _a, props = __rest(_a, ["label", "value", "onChange", "variant", "description"]);
    const toggle = () => onChange(!value);
    const textUI = (React.createElement(Div, { ml: 10, w100: true, as: "label" },
        React.createElement(Div, { h: 20, selectNone: true, alignCenter: true, as: "label" }, value ? React.createElement(Selected, null, label) : React.createElement(Body1, { mt: -2 }, label)),
        React.createElement(Body2, null,
            " ",
            description,
            " ")));
    return (React.createElement(Div, Object.assign({ dflex: true, w100: true }, props),
        React.createElement(SelectableContainer, { pRelative: true, dim: 20, onClick: () => toggle() },
            React.createElement(Div, { zIndex: 1, tabIndex: 0, onKeyDown: ({ code }) => {
                    if (code === "Space" || code === "Enter")
                        toggle();
                } },
                variant === "radio" && React.createElement(RadioInput, { isSelected: value }),
                variant === "checkbox" && React.createElement(CheckboxInput, { isSelected: value })),
            React.createElement(HoverIndicator, { pAbsolute: true })),
        label && textUI));
};
export const Checkbox = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(Selectable, Object.assign({ variant: "checkbox" }, props)));
};
export const Radio = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(Selectable, Object.assign({ variant: "radio" }, props)));
};
//# sourceMappingURL=index.js.map